import React from "react";
import PropTypes from "prop-types";
import {Button} from "@mui/material";
import {useDeleteButtonStyles} from "./buttonStyles";

const DeleteButton = ({onClick, disabled, text}) => {
  const {classes} = useDeleteButtonStyles();
  return (
    <Button
      id="delete"
      color="secondary"
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      classes={classes}
    >
      {text || "Delete"}
    </Button>
  );
};

DeleteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  text: PropTypes.string,
};

export default DeleteButton;
